"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _immutable = require("immutable");

var FolderRecord = (0, _immutable.Record)({
  folderId: null,
  objectTypeId: null,
  portalId: null,
  name: '',
  createDate: null,
  createdBy: null,
  updatedBy: null
}, 'FolderRecord');

FolderRecord.fromJS = function (json) {
  var stringId = json.hasOwnProperty('folderId') ? String(json.folderId) : null;
  return FolderRecord((0, _extends2.default)({}, json, {
    folderId: stringId
  }));
};

var _default = FolderRecord;
exports.default = _default;
module.exports = exports.default;